<template>
    <v-flex xs12>  
        <v-card>
            <v-card-title primary-title>
                <h4>Ingestelde notificaties voor: 
                    <v-tooltip bottom>
                        <v-btn @click="openSearchUserPanel()" slot="activator" flat large color="accent">{{currentUserName}}</v-btn> 
                        <span>Klik om een andere gebruiker te selecteren</span>              
                    </v-tooltip>                                                                         
                    <v-btn v-if="!userIsCurrent"  slot="activator" @click="backToOwnUser()" flat large color="accent">X</v-btn> 
                </h4>                                              
            </v-card-title>
            <v-card-text>
                <v-tabs v-model="selectedSubTab">
                    <v-tab key="asset_notifications">Asset notificaties</v-tab>
                    <v-tab key="asset_group_notifications">Assetgroep notificaties</v-tab>
                </v-tabs>     
                <v-tabs-items v-model="selectedSubTab">
                    <v-tab-item key="asset_notifications">     
                        <v-flex pt-2 pb-2>
                            <span>
                            Hier kunt u instellen hoe u notificatie berichten wilt ontvangen van een gekozen asset.</br>
                            </span>
                        </v-flex>
                        <v-data-table                            
                            no-data-text="Geen notificaties ingesteld"
                            :headers="gridHeaders"
                            :items="favoriteAssets" 
                            hide-actions>
                            <template slot="items" slot-scope="props">
                            <tr @click="changeFavoriteSettings(props.item)" style="cursor:pointer;" v-if="props.item.asset">
                                <td style="text-align:left;"> <i :class="icon(props.item)"></i> </td>
                                <td style="text-align:left;">{{props.item.asset.name}}</td>
                                <td style="text-align:left;">{{group(props.item)}}</td>
                                <td style="text-align:left;">{{yesNo(props.item.active)}}</td>
                                <td style="text-align:left;">{{yesNo(props.item.sendNotification)}}</td>                                
                                <td style="text-align:left;">{{yesNo(props.item.sendMail)}}</td>
                            </tr>
                            </template>
                        </v-data-table>      
                        <v-flex xs12 v-if="favoriteAssetsMeta && favoriteAssetsMeta.pagination && favoriteAssetsMeta.pagination.total_pages > 1" d-flex pt-2>
                            <v-pagination              
                                v-model="currentPage"
                                :length="favoriteAssetsMeta.pagination.total_pages"                           
                                @input="changePage()">
                            </v-pagination>
                        </v-flex>                               
                        <v-btn  color="accent" @click="openNewFavDialog()">Asset notificatie toevoegen </v-btn>                                                                                       
                    </v-tab-item>
                    <v-tab-item key="asset_group_notifications">     
                        <v-flex pt-2 pb-2>
                            <span>
                            Hier kunt u instellen hoe u notificatie berichten wilt ontvangen van een gekozen assetgroep. </br>
                            Deze instellingen zijn actief voor alle assets binnen deze groep.</br>
                            Als een asset eigen notificatie instellingen heeft, maar ook in een groep voorkomt waar notificaties voor zijn ingesteld, </br>
                            dan zullen de instellingen van de asset notificaties gebruikt worden.                            
                            </span>
                        </v-flex>                        
                        <v-data-table           
                            v-if="favoriteAssetGroups"                 
                            no-data-text="Geen groepsnotificaties ingesteld"
                            :headers="groupGridHeaders"
                            :items="favoriteAssetGroups" 
                            hide-actions>
                            <template slot="items" slot-scope="props">
                            <tr @click="changeFavoriteGroupSettings(props.item)" style="cursor:pointer;">
                                <td style="text-align:left;"> <i :class="props.item.assetGroup.icon"></i> </td>
                                <td style="text-align:left;">{{props.item.assetGroup.name}}</td>
                                <td style="text-align:left;">{{yesNo(props.item.active)}}</td>
                                <td style="text-align:left;">{{yesNo(props.item.sendNotification)}}</td>                                
                                <td style="text-align:left;">{{yesNo(props.item.sendMail)}}</td>
                            </tr>
                            </template>
                        </v-data-table>      
                        <v-flex xs12 v-if="favoriteAssetGroupsMeta && favoriteAssetGroupsMeta.pagination && favoriteAssetGroupsMeta.pagination.total_pages > 1" d-flex pt-2>
                            <v-pagination              
                                v-model="currentGroupPage"
                                :length="favoriteAssetGroupsMeta.pagination.total_pages"                           
                                @input="changeGroupPage()">
                            </v-pagination>
                        </v-flex>           
                        <v-flex v-if="unselectedFavoriteGroups">
                            <v-layout row wrap align-center>
                                <v-select
                                    :items="unselectedFavoriteGroups"
                                    item-value="id"
                                    item-text="name"          
                                    label="Kies een groep en klik op + om toe te voegen"
                                    v-model="newGroupId"
                                    required
                                ></v-select>                                       
                                <v-btn  color="accent" @click="openNewGroupFavDialog()">+ </v-btn>                                    
                            </v-layout>
                        </v-flex>     
                    </v-tab-item>                            
                </v-tabs-items>                                                       
            </v-card-text>           
        </v-card>
   
        <!-- FAVORITE PANEL FOR QUICK ACCESS ON GRID -->
        <asset-user-favorite v-if="favoritePannelOpen"
            :favorite="selectedFavorite" 
            :assetId="selectedAsset.id" 
            :userId="selectedUser.id"
            @favoriteSaved="favoriteSaved()"
            @panelClosed="closeFavoritePanel">
        </asset-user-favorite>        

        <!-- GROUP FAVORITE PANEL FOR QUICK ACCESS ON GRID -->
        <asset-group-user-favorite v-if="favoriteGroupPannelOpen"
            :favorite="selectedGroupFavorite" 
            :assetGroupId="selectedAssetGroupId" 
            :userId="selectedUser.id"
            @favoriteSaved="favoriteGroupSaved()"
            @panelClosed="closeFavoriteGroupPanel">
        </asset-group-user-favorite >                 
        
        <!-- ADD FAVORITE PANEL POPUP ------------------------------->
        <v-dialog v-if="newFavPanel" v-model="newFavPanel" width="600" persistent>     
            <v-card>
            <v-card-title :class="`modal-title-bar`">
                <h4>Favoriet toevoegen</h4>
                <v-spacer></v-spacer>
                <i class="fas fa-times fa-2x" style="cursor:pointer;" @click="closeAddFavoritePanel()"></i>                                
            </v-card-title>                                    
            </v-card>      
            <v-flex xs12 style="background-color:#fff">  
                <add-user-favorite :userId="selectedUser.id"></add-user-favorite>
            </v-flex>
        </v-dialog>      

    
        <!-- SEARCH USER PANEL -->
        <v-dialog v-if="searchUserPanel" v-model="searchUserPanel" width="600" persistent>     
            <v-card>
            <v-card-title :class="`modal-title-bar`">
                <h4>Gebruiker zoeken</h4>
                <v-spacer></v-spacer>
                <i class="fas fa-times fa-2x" style="cursor:pointer;" @click="closeSearchUserPanel()"></i>                                
            </v-card-title>                                    
            </v-card>      
            <v-flex xs12 style="background-color:#fff">  
                <user-search @userFound="setSearchedUser"></user-search>
            </v-flex>
        </v-dialog>           
    </v-flex>        
</template>

<script>
import * as types from '../../store/types'
import { mapGetters } from 'vuex'
import ColorMixin from '../../plugins/mixins/ColorMixin'
import MapMixin from '../../plugins/mixins/MapMixin'
import AssetUserFavorite from '../../components/asset/AssetUserFavorite'
import AssetGroupUserFavorite from '../../components/asset/AssetGroupUserFavorite'
import AddUserFavorite from '../../components/asset/AddUserFavorite'
import UserSearch from '../../components/user/UserSearch'

export default {
    components: {
        AssetUserFavorite,
        AssetGroupUserFavorite,
        AddUserFavorite,
        UserSearch
    },    
    data() {
        return {
            newGroupId:null,
            currentPage:1,
            currentGroupPage:1,
            newFavPanel:false,
            newGroupFavPanel:false,
            searchUserPanel:false,
            selectedFavorite:null,
            selectedGroupFavorite:null,
            selectedAsset:null,            
            selectedAssetGroupId:null,
            favoritePannelOpen:false,
            favoriteGroupPannelOpen:false,            
            selectedTab: 0,
            selectedSubTab:0,
            selectedUser:null,
            gridHeaders: [
                { text: "", sortable: false },
                { text: "Assetnaam", sortable: false },
                { text: "Groep", sortable: false },                    
                { text: "Actief", sortable: false },                    
                { text: "Notificatie", sortable: false },      
                { text: "Mail", sortable: false }                                  
            ],    
            groupGridHeaders: [
                { text: "", sortable: false },
                { text: "Groep", sortable: false },
                { text: "Actief", sortable: false },                    
                { text: "Notificatie", sortable: false },      
                { text: "Mail", sortable: false }                                  
            ],                                   
        }
    }, 
    computed: {
        ...mapGetters({
            currentUser: types.CURRENT_USER,
            favoriteAssets:types.USER_FAVORITE_ASSETS,
            favoriteAssetsMeta:types.USER_FAVORITE_ASSETS_META,            
            favoriteAssetGroups:types.USER_FAVORITE_ASSET_GROUPS,
            favoriteAssetGroupsMeta:types.USER_FAVORITE_ASSET_GROUPS_META,   
            assetGroups:types.ASSET_GROUPS                     
        }),
        userIsCurrent(){
            return this.selectedUser && this.selectedUser.id == this.currentUser.id ? true : false
        },
        selectedAssetId(){
            return this.selectedAsset ? this.selectedAsset.id : null
        },
        selectedUserId(){
            return this.selectedUserId ? this.selectedUser.id : null
        },
        currentUserName(){
            if(!this.selectedUser){
                return "Mijn account"
            }
            return this.userIsCurrent ? "Mijn account" : this.selectedUser.person.firstName+" "+this.selectedUser.person.lastName
        },
        unselectedFavoriteGroups(){
            if(!this.assetGroups)
                return false

            let result = this.assetGroups.filter((ele) => {                
                            // if not loaded then return always
                            if(!this.favoriteAssetGroups)
                                return true
                            // check if item is found in favorites ifso dont add to unselected                        
                            let itemFound = this.favoriteAssetGroups.find((el) => {
                                            return (el.assetGroup.id == ele.id)
                                    })                                   
                            return !itemFound 
                        })
            return result.length > 0 ? result : false
        }
    },
    methods: {
        openSearchUserPanel(){
            this.searchUserPanel= true
        },
        closeSearchUserPanel(){
            this.searchUserPanel=false
        },
        icon(item){
            return (item.asset && item.asset.group && item.asset.group.icon) ? item.asset.group.icon : ""
        },
        group(item){
            return (item.asset && item.asset.group) ? item.asset.group.name : "onbekend"
        },
        closeFavoritePanel(){
            this.favoritePannelOpen=false
        },
        closeAddFavoritePanel(){
            this.newFavPanel=false
            this.loadFavorites(this.selectedUser.id)
        },
        closeAddGroupFavoritePanel(){
            this.newGroupFavPanel=false
            this.loadGroupFavorites(this.selectedUser.id)            
        },
        yesNo(bool){
            return bool ? "Ja" : "Nee"
        },
        changeFavoriteSettings(item){           
           this.selectedFavorite   = item
           this.selectedAsset      = item.asset         
           this.favoritePannelOpen = true                    
        },
        changeFavoriteGroupSettings(item){
            this.selectedGroupFavorite = item
            this.favoriteGroupPannelOpen = true
        },
        favoriteSaved(){
            this.favoritePannelOpen=false
            this.$nextTick(() => {
                this.selectedAsset=null
                this.selectedFavorite=null
                this.loadFavorites(this.selectedUser.id)
            })
        },        
        favoriteGroupSaved(){
            this.favoriteGroupPannelOpen=false
            this.$nextTick(() => {
                this.newGroupId=null
                this.selectedAssetGroupId=null
                this.selectedGroupFavorite=null
                this.loadGroupFavorites(this.selectedUser.id)
            })
        },
        setUser(user){
            this.selectedUser = user;
            this.loadFavorites(user.id)
            this.loadGroupFavorites(user.id)
        },
        setSearchedUser(user){
            this.setUser(user)
            this.closeSearchUserPanel()
        },
        loadFavorites(userId){
            let data   = {userId:userId}
            let params = {include:"asset.group",per_page:15,page:this.currentPage}

            let vm = this
            this.$store.dispatch(types.USER_FAVORITE_ASSETS,{data:data, params:params }).then( (res) => {
                
            })
        },
        loadGroupFavorites(userId){
            let data   = {userId:userId}
            let params = {include:"assetGroup",per_page:15,page:this.currentGroupPage}

            let vm = this
            this.$store.dispatch(types.USER_FAVORITE_ASSET_GROUPS,{data:data, params:params }).then( (res) => {

                console.log("---------------------------->", this.favoriteAssetGroups)
            })
        },
        backToOwnUser(){
            this.setUser(this.currentUser)
        },
        changePage(){
            this.loadFavorites(this.selectedUser.id)
        },
        changeGroupPage(){
            this.loadGroupFavorites(this.selectedUser.id)
        },
        openNewFavDialog(){
            this.newFavPanel = true
        },
        closeFavoriteGroupPanel(){
            this.newGroupId=null
            this.selectedAssetGroupId=null            
            this.favoriteGroupPannelOpen = false
        },
        openNewGroupFavDialog(){
            if(!this.newGroupId){
                this.$notify("Selecteer een groep die je wilt toevoegen", {duration:10000, type: 'notification', icon:'warning'} ); 
            }
            else{
                this.selectedAssetGroupId = this.newGroupId
                //console.log("dit is de groep; ",this.selectedAssetGroupId)
                this.favoriteGroupPannelOpen = true
            }           
        }
    },   
    mounted(){

        // always start with own notifications
        this.setUser(this.currentUser)
        this.$store.dispatch(types.ASSET_GROUPS,{data:{}, params:{per_page:100} }).then( (res) => {})        
    } 
}
</script>

<style lang="scss" scoped>

</style>